import React, { useState } from "react";
import QuizManagement from "./QuizManagement";
import UserManagement from "./UserManagement";
import OTPViewer from "./OTPViewer";

const AdminDashboard = () => {
    const [activeTab, setActiveTab] = useState("quiz");

    return (
        <div className="max-w-6xl mx-auto p-6 bg-gray-100 rounded-lg shadow-sm">
            <header className="mb-6">
                <h1 className="text-4xl font-bold text-center text-indigo-700">
                    Admin Panel
                </h1>
                <p className="text-center text-gray-600 mt-2">
                    Manage Quizzes, Users, and OTP Codes
                </p>
            </header>
            <nav className="flex justify-center space-x-4 border-b pb-2 mb-4">
                <button
                    onClick={() => setActiveTab("quiz")}
                    className={`px-4 py-2 font-medium rounded-t-md ${activeTab === "quiz"
                        ? "bg-white text-indigo-700 border-b-2 border-indigo-700"
                        : "text-gray-600 hover:text-indigo-700"
                        }`}
                >
                    Quiz Management
                </button>
                <button
                    onClick={() => setActiveTab("users")}
                    className={`px-4 py-2 font-medium rounded-t-md ${activeTab === "users"
                        ? "bg-white text-indigo-700 border-b-2 border-indigo-700"
                        : "text-gray-600 hover:text-indigo-700"
                        }`}
                >
                    User Management
                </button>
                <button
                    onClick={() => setActiveTab("otp")}
                    className={`px-4 py-2 font-medium rounded-t-md ${activeTab === "otp"
                        ? "bg-white text-indigo-700 border-b-2 border-indigo-700"
                        : "text-gray-600 hover:text-indigo-700"
                        }`}
                >
                    OTP Codes
                </button>
            </nav>
            <div className="bg-white p-6 rounded-b-md shadow">
                {activeTab === "quiz" && <QuizManagement />}
                {activeTab === "users" && <UserManagement />}
                {activeTab === "otp" && <OTPViewer />}
            </div>
        </div>
    );
};

export default AdminDashboard;
